<template>
  <div class="card-padding histogram">
    <div class="account-info">
      <div class="account-img">
        <img
          :src="accountInfo.user_info.avatar || ''"
          alt=""
        >
      </div>
      <div class="account-content">
        <div class="name content">
          {{ accountInfo.user_info.user_name }}
        </div>
        <div class="role content">
          {{ accountInfo.user_info.role_name }}
        </div>
        <div class="phone content">
          {{ accountInfo.user_info.mobile }}
        </div>
      </div>
    </div>
    <el-divider />
    <ul class="company">
      <li>
        <div class="title">
          企业全称
        </div>
        <div class="content">
          {{
            accountInfo && accountInfo.workwechat_info && accountInfo.workwechat_info.corp_full_name
          }}
        </div>
      </li>
      <li>
        <div class="title">
          企业 ID
          <el-tooltip
            effect="dark"
            content="可在企业微信-我的企业中查看"
            placement="top"
          >
            <i class="el-icon-info tooltip" />
          </el-tooltip>
        </div>
        <div class="content">
          {{ accountInfo && accountInfo.workwechat_info && accountInfo.workwechat_info.corpid }}
        </div>
      </li>
    </ul>
    <el-divider />
    <div class="shop">
      <div class="shop-img">
        <img
          :src="companyInfo.logo"
          alt=""
        >
      </div>
      <div class="shop-info">
        <div class="name">
          {{ companyInfo.brand_name }}
        </div>
        <div class="company-id">
          COMPANYID: {{ companyInfo.company_id }}
        </div>
      </div>
    </div>
    <el-divider />
    <div class="time">
      <div class="title">
        到期时间
      </div>
      <div class="content">
        {{ accountInfo.resource_info.expired_str }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data () {
    return {
      accountInfo: {
        user_info: {
          avatar: '',
          user_name: '',
          role_name: '',
          mobile: ''
        },
        workwechat_info: {
          corp_full_name: '',
          corpid: ''
        },
        resource_info: {
          expired_str: ''
        }
      },
      companyInfo: {}
    }
  },
  mounted () {
    this.getAccountInfo()
    this.getCompanyInfo()
  },
  methods: {
    async getAccountInfo () {
      const data = await this.$api.setting.getAccountInfo(this.accountParams)
      if (data) {
        this.accountInfo = data
      }
    },
    async getCompanyInfo () {
      const data = await this.$api.setting.getCompanyInfo(this.companyParams)
      if (data) {
        this.companyInfo = data
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.histogramContent {
  width: 100%;
  transition: all 0.3s ease-in;
}
.card-padding {
  padding: 20px;
  background: #fff;
  margin-bottom: 20px;

  &.histogram {
    .main {
      font-size: 18px;
      color: black;
      font-weight: 500;
    }
  }
}
@media only screen and (max-width: 1600px) {
  .histogram {
    .main {
      font-size: 14px;
    }
  }
}

.histogram {
  ::v-deep {
    .el-divider--horizontal {
      margin: 20px 0;
    }
  }
}
.account-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .account-img {
    width: 76px;
    height: 64px;
    img {
      width: 64px;
      height: 64px;
      border-radius: 4px;
    }
  }
  .account-content {
    flex: 1;
    line-height: 24px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    .content {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
    .name {
      width: 100%;
      font-size: 16px;
      color: #303133;
    }
    .role {
      font-size: 14px;
      color: #606266;
    }
    .phone {
      font-size: 14px;
      color: #606266;
    }
  }
}
.company {
  li {
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 40px;
    .title {
      color: #909399;
      width: 76px;
    }
    .content {
      color: #606266;
      flex: 1;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
}
.shop {
  display: flex;
  align-items: center;
  line-height: 28px;
  .shop-img {
    width: 76px;
    height: 56px;
    img {
      width: 56px;
      height: 56px;
      border-radius: 4px;
    }
  }
  .shop-info {
    flex: 1;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    .name {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
}
.time {
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 24px;
  .title {
    color: #909399;
    width: 76px;
  }
  .content {
    color: #606266;
    flex: 1;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
}
</style>
